var React = require('react');

function ExpandLess (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"expand_less_24px"},React.createElement("path",{"id":"icon/navigation/expand_less_24px","d":"M12 8.29501L6 14.295L7.41 15.705L12 11.125L16.59 15.705L18 14.295L12 8.29501Z","fill":"#3B10C1"})));
}

ExpandLess.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExpandLess;

ExpandLess.default = ExpandLess;
